<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { showToast } from '../lib/toast';
  
  export let isOpen = false;
  export let invitationLink = '';
  export let onClose: () => void;

  // Check if the browser supports the Web Share API
  function isShareAvailable(): boolean {
    return Boolean(navigator.share && navigator.canShare);
  }

  async function shareInvitationLink() {
    try {
      if (isShareAvailable()) {
        await navigator.share({
          title: $_('invitation.shareTitle'),
          text: $_('invitation.shareText'),
          url: invitationLink
        });
      } else {
        // Fallback for browsers that don't support sharing
        await copyToClipboard();
      }
    } catch (error) {
      console.error('Error sharing invitation link:', error);
      // Fallback to copy if sharing fails
      await copyToClipboard();
    }
  }

  async function copyToClipboard() {
    try {
      await navigator.clipboard.writeText(invitationLink);
      showToast($_('invitation.copiedToClipboard'), 'success');
    } catch (error) {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = invitationLink;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showToast($_('invitation.copiedToClipboard'), 'success');
    }
  }
</script>

{#if isOpen}
<dialog class="z-2000" open>
  <article>
    <header>
      <h3>{$_('invitation.title')}</h3>
      <button aria-label="Close" class="close" on:click={onClose}></button>
    </header>
    
    <div class="invitation-content">
      <p>{$_('invitation.description')}</p>
      
      <div class="link-container">
        <input 
          type="text" 
          readonly 
          value={invitationLink}
          class="invitation-link"
        />
      </div>
      
    </div>

    <footer class="">
      <button type="button" class="success full-width" on:click={shareInvitationLink}>
        <ion-icon name="share-outline"></ion-icon>
        {isShareAvailable() ? $_('invitation.shareButton') : $_('invitation.copyButton')}
      </button>
    </footer>
  </article>
</dialog>
{/if}

<style>
  .z-2000 {
    z-index: 2000;
  }

  .invitation-content {
    margin: 1rem 0;
  }

  .link-container {
    margin: 1rem 0;
  }

  .invitation-link {
    width: 100%;
    font-family: monospace;
    font-size: 0.875rem;
    background-color: var(--pico-background-color);
    border: 1px solid var(--pico-border-color);
    padding: 0.75rem;
    border-radius: 4px;
    cursor: text;
  }

  .invitation-link:focus {
    outline: 2px solid var(--pico-primary);
    outline-offset: 2px;
  }

  .warning-text {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem;
    background-color: var(--pico-secondary-background);
    border-radius: 4px;
    font-size: 0.875rem;
    color: var(--pico-secondary-text);
    margin-top: 1rem;
  }

  .warning-text ion-icon {
    flex-shrink: 0;
    font-size: 1.125rem;
  }

  footer {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 1.5rem;
  }

  footer button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  footer button ion-icon {
    font-size: 1rem;
  }
</style>
